import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Divider } from '@mui/material';

const CardRow = ({ label, value, flexDisplayedValue }) => {
  return (
    <Grid container alignItems={'center'}>
      <Grid item xs={6}>
        <Box>{label}</Box>
      </Grid>
      <Grid item xs={6}>
        <Box display={flexDisplayedValue ? 'flex' : ''} justifyContent={flexDisplayedValue ? 'flex-end' : ''} alignItems='center'>
          {value}
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ m: 0.25 }} />
      </Grid>
    </Grid>
  );
};

CardRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  flexDisplayedValue: PropTypes.bool
};

export default CardRow;
